module.exports = __webpack_public_path__ + "img/section_external_locations.fe4bfd91.png";